import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3006a0ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3006a0ee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006a0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3006a0ee')) {
      api.createRecord('3006a0ee', component.options)
    } else {
      api.reload('3006a0ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3006a0ee&scoped=true", function () {
      api.rerender('3006a0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Banner2/index.vue"
export default component.exports